import React from "react";

export interface WellHatProps {
	title: React.ReactNode | string;
	link: React.ReactNode;
}

const WellHat: React.FC<WellHatProps> = ({ title, link }) => {
	return (
		<div className="well-hat">
			<div className="well-hat-title">{title}</div>
			<div className="well-hat-link">{link}</div>
		</div>
	);
};

export default WellHat;
